/**
 * The Gamify widget puts a full-screen wrapper with an inline z-index of 2147483646
 * into whatever container it mounts into. Mounting it into this app-owned host keeps
 * that number inside the floating layer, so dialogs and blocking prompts (redeem
 * approval) stay above the widget.
 */
export const GAMIFY_HOST_CLASS = 'relative z-floating';

export interface GamifyMountOptions {
  apiBaseUrl: string;
  tenantSlug: string;
  getUserToken: () => string | Promise<string | null>;
  fabPosition?: 'right-bottom' | 'left-bottom';
}

export interface GamifyWidgetApi {
  mount: (options: GamifyMountOptions & { container?: HTMLElement | string }) => void;
}

export function mountGamifyWidget(widget: GamifyWidgetApi, host: HTMLElement, options: GamifyMountOptions): void {
  widget.mount({ ...options, container: host });
}
